import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const DialogBox = ({ isOpen, title, message, buttons, toggle, size }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered backdrop="static" size={size}>
            {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
                {buttons.map((btn, index) => (
                    <Button                    
                        key={index}
                        outline={btn.outline || false}
                        color={btn.color || 'secondary'}
                        onClick={btn.onClick}
                    >
                        {btn.icon && <i className={`me-2 ${btn.icon}`}></i>}
                        {btn.label}
                    </Button>
                ))}
            </ModalFooter>
        </Modal>
    );
};

export default DialogBox;